module.exports = __webpack_public_path__ + "img/icon-sort-arrow-up.ef373e36.svg";